<script>
	import Collapse from '../Helper/Collapse.svelte';

	// Not the prettiest solution, but it works
	// When you add a Collapse component, you also need to add an element to the array
	let status = [true, false, false]
	function handleToggle (event) {
		const { id, visible } = event.detail
		let _status = [false, false, false]
		_status[id] = visible
		status = _status
	}
</script>

<div class="instruction">
	<Collapse title="Footnotes to the Making of Earths" id={0} visible={status} on:toggle={handleToggle}>
		The online screening of <em>Making of Earths</em> is footnoted with personal field-notes, references and informative accounts taken during Asia Bazdyrieva and Solveig Suess’s year-long, documentary-led research into ‘Geocinema’- the data infrastructures of the Belt and Road and their cinematic feedback loops. Organised through 7 chapters, the footnotes are visible as phases of the eclipse, clickable on the screen's leftside bar.
	</Collapse>
	<Collapse title="Credits" id={1} visible={status} on:toggle={handleToggle}>
		Footnotes: Asia Bazdyrieva & Solveig Suess<br />
		Design, Development: <a href="https://jonasparnow.com">Jonas Parnow</a><br />
		Graphic design: Solveig Suess<br />
		Copy-editing, proofreading: Miranda Johnson<br /><br />
		Produced in collaboration with the ZKM | Center for Art and Media Karlsruhe, as part of the virtual platform of the exhibition <em>Critical Zones</em>.
	</Collapse>
	<Collapse title="Geocinema" id={2} visible={status} on:toggle={handleToggle}>
		<a href="https://geocinema.network/" class="link" target="_blank">Geocinema</a> is a project made in collaboration between Asia Bazdyrieva and Solveig Suess with Jessika Khazrik on music and sound. The project traces the physical infrastructures and abstracted processes which make up the supply chains of perception, attentive to the situated histories of sensing techniques which are framing movements of the cosmos, atmospheres, oceans, surveilling flows of bodies and their congregations, in order to unstitch and restitch given narratives about earths. Here, the representation of earth is the sum of a decentralized editing process with its image anything but whole.
	</Collapse>
</div>